import React, { lazy, Suspense, useState } from 'react'
import { useFeatureFlag } from '@fs/zion-flags'
import { getSessionId, getAnonSession } from '@fs/zion-session'

const PreRegisterRTBanner = lazy(() => import('./PreRegisterRTBanner'))
const OpenRegisterRTBanner = lazy(() => import('./OpenRegisterRTBanner'))
const BlackFridayRTBanner = lazy(() => import('./BlackFridayRTBanner'))
const EarlyBirdEndRTBanner = lazy(() => import('./EarlyBirdEndRTBanner'))
const ScheduleAvailableRTBanner = lazy(() => import('./ScheduleAvailableRTBanner'))
// const LastChanceRTBanner = lazy(() => import('./LastChanceRTBanner'))
const LastChanceCollapsedRTBanner = lazy(() => import('./LastChanceCollapsedRTBanner'))
// const RelativesRTBanner = lazy(() => import('./RelativesRTBanner'))
const RelativesCollapsedRTBanner = lazy(() => import('./RelativesCollapsedRTBanner'))
// const KeepsakesRTBanner = lazy(() => import('./KeepsakesRTBanner'))
const KeepsakesCollapsedRTBanner = lazy(() => import('./KeepsakesCollapsedRTBanner'))
// const LiveEventRTBanner = lazy(() => import('./LiveEventRTBanner'))
const LiveEventCollapsedRTBanner = lazy(() => import('./LiveEventCollapsedRTBanner'))
// const FamousRelativesRTBanner = lazy(() => import('./FamousRelativesRTBanner'))
const FamousRelativesCollapsedRTBanner = lazy(() => import('./FamousRelativesCollapsedRTBanner'))
// const RecapRTBanner = lazy(() => import('./RecapRTBanner'))
const RecapCollapsedRTBanner = lazy(() => import('./RecapCollapsedRTBanner'))

const FHCTestBanner = lazy(() => import('./FhcTestBanner')) // Can be removed after testing concludes

async function detectSession(hasSessionCallBack) {
  hasSessionCallBack('loading')
  if (!getSessionId()) {
    await getAnonSession()
  }
  hasSessionCallBack(true)
}
function useDetectSession() {
  const [sessionChecked, setSessionChecked] = useState(false)
  if (!sessionChecked) detectSession(setSessionChecked)
  return sessionChecked
}
function SessionPrep({ children }) {
  // There needs to be a session Id before we can use the `ThemisPrmDiscoveryCenter` permission. Note, this permission is only true in a family history center on prod.
  const ready = useDetectSession() === true
  if (ready) {
    return children
  }
  return null
}

function BannerOrPanel({ showRTBannerFlag }) {
  switch (showRTBannerFlag.treatment) {
    case 'announce':
      return <PreRegisterRTBanner />
    case 'earlyBird':
      return <OpenRegisterRTBanner />
    case 'blackFriday':
      return <BlackFridayRTBanner />
    case 'lastCall':
      return <EarlyBirdEndRTBanner />
    case 'schedule':
      return <ScheduleAvailableRTBanner />
    case 'lastChance':
      return <LastChanceCollapsedRTBanner />
    case 'relatives':
      return <RelativesCollapsedRTBanner />
    case 'keepsakes':
      return <KeepsakesCollapsedRTBanner />
    case 'live':
      return <LiveEventCollapsedRTBanner />
    case 'famous':
      return <FamousRelativesCollapsedRTBanner />
    case 'recap':
      return <RecapCollapsedRTBanner />

    case 'fhc-test':
      return <FHCTestBanner />
    default:
      return null
  }
}

export default function RootsTechBanners() {
  const utcMillisecondsSinceEpoch = new Date().getTime()
  const customAttributes = {
    time: utcMillisecondsSinceEpoch,
  }
  const showRTBannerFlag = useFeatureFlag('home_nlihp_showRootsTechBanner', customAttributes)
  const showRTBannerOrPanel = showRTBannerFlag.isOn

  if (showRTBannerOrPanel) {
    return (
      <Suspense fallback="">
        <SessionPrep>
          <BannerOrPanel showRTBannerFlag={showRTBannerFlag} />
        </SessionPrep>
      </Suspense>
    )
  }
  return null
}
